import { hsCodeRoute, hsCustomsRoute, jobFileRoute, type ApiRoutes } from '@hana/data';
import { apiRoutes as ezy } from '@hana/zone-ezy';
import { apiRoutes as lys } from '@hana/zone-lys';
import { apiRoutes as mee } from '@hana/zone-mee';

/** Thực thể đọc từ worker `api`. Khi một vùng có route thật (A-06, A-08) + hàm đổi JSON → kiểu của màn, khai ở đây; màn không phải sửa. */
export const API_ROUTES: ApiRoutes = { ...ezy, ...mee, ...lys, hsCode: hsCodeRoute, hsCustoms: hsCustomsRoute, jobFile: jobFileRoute };
